import React from "react";
import { useSelector } from "react-redux";
import "./AllacciamentoCase.scss";
import CaseGenerator from "../../../CaseGenerator/CaseGenerator";
import { CaseForms,UserRoleEnum } from "../../../../helpers/enums";
import { SwitchUser } from "../../../../helpers/helpers";
import { useTranslation } from "react-i18next";
import digitalizzazioneCustomModalSuccess
  from "../../../CaseGenerator/custom-success-modal/digitalizzazioneCustomModalSuccess";

const AllacciamentoCase = () => {
  const auth = useSelector((state) => state.auth);
  const {user} = auth;
  const userProfile = SwitchUser(auth);
  const role = userProfile ? userProfile.role : null;
  const { t } = useTranslation();
  const blockForm = userProfile.isCondominiumAdminDisabled && role === UserRoleEnum.CONDOMINIUM_ADMIN;
  return (
    <div className="AllacciamentoCase" data-testid="AllacciamentoCase">
      <CaseGenerator
        type={CaseForms.Allaccio}
        block={blockForm}
        signDigital={user.role !== 'MUNICIPAL_OPERATOR' ? true : false} // this is mandatory if you want custom success modal
        successModalCustom={
          (props) => digitalizzazioneCustomModalSuccess({t:t,content: "cases.digitalization.success", ...props})
        }
        excludeSteps={user.role === 'MUNICIPAL_OPERATOR' ? [9]: []}
        blockText={blockForm && t("associate-contract.block-view")}
      />
    </div>
  );
};

AllacciamentoCase.propTypes = {};

export default AllacciamentoCase;
